import axios from 'axios';
import { host } from '../../helper/config';

export function notificationFailure(error) {
  const status = error.response?.status;
  const payload = error.response?.data;
  const code = payload?.error?.code || (status === 403 ? 'FORBIDDEN' : status === 401 ? 'UNAUTHORIZED' : 'REQUEST_FAILED');
  const hints = {
    FORBIDDEN: 'Phiên tài khoản hiện tại không được phép quản lý thông báo. Vui lòng đăng nhập bằng tài khoản Admin.',
    TEST_RECIPIENT_NOT_FOUND: 'Không tìm thấy tài khoản nhận thử. Hãy tìm và chọn lại khách hàng.',
    TEST_RECIPIENT_INACTIVE: 'Tài khoản nhận thử chưa hoạt động. Hãy chọn tài khoản đang hoạt động.',
    UNAUTHORIZED: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
    VERSION_CONFLICT: 'Dữ liệu đã thay đổi. Nội dung đang nhập được giữ lại; hãy tải bản mới để đối chiếu.',
    NOTIFICATION_INBOX_DISABLED: 'Backend chưa bật hộp thông báo. Các dữ liệu và thao tác sẽ có sau khi cấu hình được mở.',
    NOTIFICATION_CAMPAIGNS_DISABLED: 'Backend chưa bật chiến dịch thông báo.',
    NOTIFICATION_CONFIGURATION_REQUIRED: 'Backend chưa đủ cấu hình thông báo.',
    NOTIFICATION_ASSET_CONFIGURATION_REQUIRED: 'Backend chưa cấu hình kho ảnh thông báo.',
  };
  const failure = new Error(hints[code] || payload?.error?.message || (status ? 'Không thể thực hiện yêu cầu. Vui lòng thử lại.' : 'Chưa nhận được phản hồi. Hãy thử lại cùng yêu cầu để tránh tạo trùng.'));
  failure.code = code;
  failure.status = status;
  failure.fields = payload?.error?.fields || {};
  failure.requestId = payload?.meta?.requestId || null;
  failure.uncertain = !status || status >= 500;
  return failure;
}

/** Separate contract from the legacy /admin-notification POST wrappers. */
export function createNotificationApi(token) {
  return async (method, path, options = {}) => {
    const headers = { Authorization: token };
    if (!(options.body instanceof FormData)) headers['Content-Type'] = 'application/json';
    if (options.version !== undefined) headers['If-Match'] = `"${options.version}"`;
    if (options.key) headers['Idempotency-Key'] = options.key;
    try {
      const response = await axios({ method, url: `${host}/admin-notifications/v1${path}`, headers,
        params: options.query, data: options.body, timeout: options.body instanceof FormData ? 60000 : 30000 });
      if (!response.data || !Object.prototype.hasOwnProperty.call(response.data, 'data')) {
        throw new Error('Invalid notification envelope');
      }
      return { data: response.data.data, etag: response.headers?.etag, meta: response.data.meta };
    } catch (error) { throw notificationFailure(error); }
  };
}
